export default function (Alpine) {
    Alpine.directive(
        "css-variable",
        (el, { modifiers, expression }, { effect, evaluateLater }) => {
            let propValue = evaluateLater(expression)

            effect(() =>
                propValue((value) => {
                    modifiers.forEach((property) => {
                        el.style.setProperty(`--${property}`, value)
                    })
                })
            )
        }
    )
}
